import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertCircle } from 'lucide-react';
export function StickyHeader() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed top-0 left-0 w-full bg-[#c4704f] text-white z-50 shadow-lg py-2 px-4 text-xs md:text-sm font-medium" data-id="element-11">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 text-center md:text-left" data-id="element-12">
        <div className="flex items-center gap-2" data-id="element-13">
          <span className="bg-red-600 text-white px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider animate-pulse" data-id="element-14">
            Urgente
          </span>
          <span className="hidden md:inline" data-id="element-15">
            🔥 HOY: Acceso inmediato + Guía completa + Bonos incluidos
          </span>
          <span className="md:hidden" data-id="element-16">🔥 Oferta termina pronto</span>
        </div>

        <div className="flex items-center gap-4" data-id="element-17">
          <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-full" data-id="element-18">
            <span className="opacity-90" data-id="element-19">Termina en:</span>
            <CountdownTimer className="text-white" showIcon={false} data-id="element-20" />
          </div>

          <div className="hidden md:flex items-center gap-1 text-yellow-200" data-id="element-21">
            <AlertCircle className="w-4 h-4" data-id="element-22" />
            <span data-id="element-23">Solo quedan 7 copias</span>
          </div>

          <button onClick={scrollToPurchase} className="bg-white text-[#c4704f] px-3 py-1 rounded-full font-bold hover:bg-gray-100 transition-colors shadow-sm whitespace-nowrap" data-id="element-24">
            DESCARGAR AHORA
          </button>
        </div>
      </div>
    </div>;
}